module.exports = function() {
  return new Worker(__webpack_public_path__ + "db2abade4582f1e0bb0c.worker.js");
};